let $ = window.jQuery;

import 'select2';
import 'select2/dist/css/select2.css';

Drupal.behaviors.newsFilter = {
  attach: function (context) {
    $(
      function () {
        let $selects = $('.select2', context);

        /**
         * Listen for changes to the Select2 elements and updated the shadow selections.
         */
        if ($selects.length > 0) {
          $(document).on('change.select2', function (e) {
            e.stopPropagation();
            const $target = $(e.target);
            const $parent = $target.parent();

            copy_shadow_selection($parent);
          });

          /**
           * Update the shadow selections on page load.
           */
          $(document).ready(function() {
            $.each($selects, (index, element) => {
              const $element = $(element);
              const $parent = $element.parent();

              copy_shadow_selection($parent);
            });
          });
        }
      }
    );

    /**
     * Create a shadow of the selected options that we can style separately.
     *
     * @param $parent jQuery Object
     */
    function copy_shadow_selection($parent) {
      const $container = get_result_container($parent);
      let $results = $('.selection .select2-selection__rendered', $parent).clone();

      set_results($container, $results);
    }

    /**
     * Create a container for our shadow results if it isn't there already.
     *
     * @param $parent
     * @returns {*|jQuery|HTMLElement}
     */
    function get_result_container($parent) {
      return $('.result-container', $parent).length > 0 ? $('.result-container', $parent) : $parent.append('<div class="result-container"></div>').find(".result-container", $parent);
    }

    /**
     * Copy the shadow results to the container.
     * Attach an event to the remove selection button.
     *
     * @param $container
     * @param $results
     */
    function set_results($container, $results) {
      $('.select2-selection__choice__remove', $results).on('click', remove_result);
      $container.html($results);
    }

    /**
     * Get the selected options from Select2 and return the ids.
     *
     * @param $select
     * @returns {*[]}
     */
    function get_selected($select) {
      let data = $select.select2('data');
      let selected = [];

      $.each(data, (index, value) => {
        selected.push(parseInt(value.id));
      });

      return selected;
    }

    /**
     * Update the Select2 options and trigger a change.
     *
     * @param $select
     * @param values
     */
    function set_selected($select, values) {
      $select.val(values).trigger('change');
    }

    /**
     * Get the selected options and remove the one that triggered the event.
     *
     * @param event
     */
    function remove_result(event) {
      const $target = $(event.target);
      const $parent = $target.closest('.js-form-type-select');
      const $button = $target.closest('button');
      const $select = $('select', $parent);
      let buttonId = $button.attr('aria-describedby');
      let matches = buttonId.match(/(?<id>[0-9]*)$/); // Option ID is in the last digits of the button ID.

      if (typeof matches.groups.id !== 'undefined') {
        let selected = get_selected($select);
        const index = selected.indexOf(parseInt(matches.groups.id));

        if (index > -1) {
          selected.splice(index, 1);
        }

        set_selected($select, selected);
      }
    }
  }
};
